<template>
  <a-row class="busyness-row" :gutter="16">
    <a-col :span="12" style="margin-bottom: 18px">
      <div class="busyness-card">
        <a-statistic
          class="busyStatistic"
          title="全部"
          :value="total"
          :value-style="{
            fontSize: '32px',
            fontWeight: 500,
            color: '#6f42ff'
          }"
        >
        </a-statistic>
      </div>
    </a-col>
    <a-col :span="12" style="margin-bottom: 18px">
      <div class="busyness-card busyness-card_normal">
        <a-statistic
          class="busyStatistic"
          title="正常"
          :value="dataSource.normal"
          :value-style="{
            fontSize: '32px',
            fontWeight: 500,
            color: '#51a8f2'
          }"
        >
        </a-statistic>
      </div>
    </a-col>
    <a-col :span="12" style="margin-bottom: 18px">
      <div class="busyness-card busyness-card_busy">
        <a-statistic
          class="busyStatistic"
          title="繁忙"
          :value="dataSource.busy"
          :value-style="{
            fontSize: '32px',
            fontWeight: 500,
            color: '#fa8c16'
          }"
        >
        </a-statistic>
      </div>
    </a-col>
    <a-col :span="12" style="margin-bottom: 18px">
      <div class="busyness-card busyness-card_idle">
        <a-statistic
          class="busyStatistic"
          title="空闲"
          :value="dataSource.idle"
          :value-style="{
            fontSize: '32px',
            fontWeight: 500,
            color: '#43B94D'
          }"
        >
        </a-statistic>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import { getServiceSourceBusyness } from '@/api/service.js'

export default {
  name: 'BusynessCard',
  props: {
    serviceId: {
      type: String
    }
  },
  data () {
    return {
      dataSource: {}
    }
  },
  computed: {
    total () {
      if (this.dataSource) return this.dataSource.busy + this.dataSource.idle + this.dataSource.normal || 0
      return 0
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      getServiceSourceBusyness(this.serviceId).then(res => {
        this.dataSource = res.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
.busyness-row {
  padding-top: 20px;
  .busyness-card {
    height: 100px;
    background-image: url('~@/assets/images/busyness_all.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .busyness-card_normal {
    background-image: url('~@/assets/images/busyness_normal.png');
  }
  .busyness-card_idle {
    background-image: url('~@/assets/images/busyness_idle.png');
  }
  .busyness-card_busy {
    background-image: url('~@/assets/images/busyness_busy.png');
  }
}
</style>
